@if (images) {
  <div class="img__list">
    <!-- esse ng-content só serve para atribuir o app-select que ta dentro da tag app-verification-images-preview no componente verification-data-modal -->
    <ng-content></ng-content>
    @if (hasBack) {
      <app-switch-tabs
        name="type"
        [options]="[
          [false, 'button.documentFront' | translate],
          [true, 'button.documentBack' | translate]
        ]"
        [(ngModel)]="showBackPictures"
        [ngModelOptions]="{ standalone: true }"
      ></app-switch-tabs>
    }

    <!-- Front -->
    @if (hasImage(images.front)) {
      <a [href]="images.front | safeUrl" target="_blank" [hidden]="showBackPictures">
        <img class="img__list-item" [src]="images.front | safeUrl" (error)="markAsFailed(images.front)" />
      </a>
    }

    <!-- Back -->
    @if (hasImage(images.back)) {
      <a [href]="images.back | safeUrl" target="_blank" [hidden]="!showBackPictures">
        <img class="img__list-item" [src]="images.back | safeUrl" (error)="markAsFailed(images.back)" />
      </a>
    }

    <!-- Selfie -->
    @if (hasImage(images.selfie)) {
      <a [href]="images.selfie | safeUrl" target="_blank" class="img__list-selfie">
        <img class="img__list-item" [src]="images.selfie | safeUrl" (error)="markAsFailed(images.selfie)" />
      </a>
    }
  </div>
}
